module.exports = {
  src: __webpack_public_path__ + "assets/images/mic-muted-icon.79736bbf1a3135f1.svg",
  width: 32,
  height: 32,
  toString: function() { return __webpack_public_path__ + "assets/images/mic-muted-icon.79736bbf1a3135f1.svg"; }
};